import { Component } from '@angular/core';
import { NgIf } from '@angular/common';

import { LoadingService } from './loading.service';

import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'app-loading',
  standalone: true,
  imports: [NgIf,ProgressSpinnerModule],
  template: `
    <div class="loading-overlay" *ngIf="loadingService.isLoading()">
        <p-progress-spinner ariaLabel="loading"></p-progress-spinner>
    </div>
  `,
  styles: [`
    .loading-overlay {
      position: fixed;
      top: 0; left: 0; width: 100%; height: 100%;
      background: rgba(0, 0, 0, 0.3);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 9999;
    }
  `]
})
export class LoadingComponent {
  constructor(public loadingService: LoadingService) {}
}
